import React, { Component, PropTypes } from 'react';
import {
  Button,
  Modal,
  FormGroup,
  Form,
  FormControl,
  ControlLabel,
} from '@sketchpixy/rubix';
import { ClipLoader } from 'react-spinners';
import { css } from 'react-emotion';

import ServiceType from '../../../constants/ServiceType';

import { getRapaelClient, updateRapaelClient } from '../../../api/api';

const override = css`
  margin-top: -550px;
`;

class ApkEditModal extends Component {
  constructor(props) {
    super(props);

    this.onFileChange = this.onFileChange.bind(this);

    this.state = {
      rapaelClient: { serviceTypeName: '', downloadUrl: '', file: null },
      file: null,
      loading: false,
    };
  }

  serviceTypeChangeHandler = (event) => {
    var rapaelClient = { ...this.state.rapaelClient }
    rapaelClient.serviceTypeName = event.target.value;
    this.setState({
      rapaelClient: rapaelClient,
    });
  }

  onPackageNameChange = (event) => {
    var rapaelClient = { ...this.state.rapaelClient }
    rapaelClient.packageName = event.target.value;
    this.setState({
      rapaelClient: rapaelClient,
    });
  }

  onVersionNameChange = (event) => {
    var rapaelClient = { ...this.state.rapaelClient }
    rapaelClient.versionName = event.target.value;
    this.setState({
      rapaelClient: rapaelClient,
    });
  }

  onVersionCodeChange = (event) => {
    var rapaelClient = { ...this.state.rapaelClient }
    rapaelClient.versionCode = event.target.value;
    this.setState({
      rapaelClient: rapaelClient,
    });
  }

  onFileChange(e) {
    this.setState({
      file: e.target.files[0],
    });
  }


  saveRapaelClient = () => {
    let self = this;
    const formData = new FormData();
    if (self.state.file !== null)
      formData.append('file', self.state.file);

    _.forOwn(self.state.rapaelClient, function (value, key) {
      formData.append(key, value);
    });

    self.setState({
      loading: true,
    });
    updateRapaelClient(formData, (err, res) => {
      self.setState({
        loading: false,
      });
      if (err) {
        vex.dialog.alert('Failed to update Rapael Client!');
      } else {
        vex.dialog.alert('Rapael Client Updated!');
        self.setState({
          rapaelClient: res.client,
          file: null,
        }, () => {
        });
      }
    });
  }

  onShowModal = () => {
    if (this.props.rapaelClientId) {
      getRapaelClient(this.props.rapaelClientId, (err, res) => {
        this.setState({
          rapaelClient: res.client,
        });
      });
    } else {
      let rapaelClient = { rapaelClientId: "", serviceTypeName: '', downloadUrl: '' };
      if (this.props.serviceType) {
        rapaelClient.serviceTypeName = this.props.serviceType;
      }

      this.setState({
        rapaelClient,
      });
    }


  }

  render() {
    return (
      <Modal
        show={this.props.showModal}
        onHide={this.props.closeModal}
        onEntered={this.onShowModal}
        backdrop="static"
        style={{ width: '100%' }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit APK</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <FormGroup controlId="formControlsFile">
              <ControlLabel>Attach APK</ControlLabel>
              <FormControl type="file" name="file" onChange={this.onFileChange} />
            </FormGroup>
            {this.props.rapaelClientId && (
              <FormGroup controlId="readOnly">
                <ControlLabel>Attached APK</ControlLabel>
                <FormControl
                  readOnly type="text" placeholder="Attached File"
                  value={this.state.rapaelClient.downloadUrl.split('/').pop()}
                />
              </FormGroup>
            )}

            <FormGroup controlId="formControlsFile">
              <ControlLabel>Service Type</ControlLabel>
              <FormControl
                componentClass="select"
                onChange={this.serviceTypeChangeHandler}
                value={this.state.rapaelClient.serviceTypeName}
              >
                {
                  ServiceType.enumValues.map(serviveType => (
                    <option key={serviveType.name} value={serviveType.name}>{serviveType.title}</option>
                  ))
                }
              </FormControl>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Package Name</ControlLabel>
              <FormControl
                type="text" placeholder="Package Name" value={this.state.rapaelClient.packageName}
                onChange={this.onPackageNameChange}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Version Name</ControlLabel>
              <FormControl
                type="text" placeholder="Version Name" value={this.state.rapaelClient.versionName}
                onChange={this.onVersionNameChange}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>Version Code</ControlLabel>
              <FormControl
                type="text" placeholder="Version Code" value={this.state.rapaelClient.versionCode}
                onChange={this.onVersionCodeChange}
              />
            </FormGroup>
          </Form>
          <ClipLoader
            className={override}
            sizeUnit={'px'}
            size={500}
            color={'#123abc'}
            loading={this.state.loading}
          >
          </ClipLoader>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.saveRapaelClient}>Save</Button>
          <Button onClick={this.props.closeModal}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

//rapaelClientId
ApkEditModal.propTypes = {
  rapaelClientId: PropTypes.number,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default ApkEditModal;



// WEBPACK FOOTER //
// ./src/routes/ReleaseMgnt/components/ApkEditModal.js